import React, { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";

export default function PopUp({ onClose }) {
  const [requisites, setRequisites] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const [randomCode, setRandomCode] = useState("");

  // Генерация случайного 6-значного числа
  const generateRandomCode = () => {
    const code = Math.floor(100000 + Math.random() * 900000);
    setRandomCode(code);
  };

  // Хендлер для свайпа вниз
  const handleSwipeDown = (e) => {
    const touchStart = e.touches[0].clientY;

    const handleTouchMove = (e) => {
      const touchEnd = e.touches[0].clientY;
      if (touchEnd > touchStart + 50) {
        setIsVisible(false);
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleTouchEnd);
      }
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };

    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);
  };

  useEffect(() => {
    generateRandomCode(); // Генерируем случайный код при монтировании компонента

    const savedData = localStorage.getItem("bioData");
    if (savedData) {
      try {
        // Кодируем данные с поддержкой UTF-8
        const encodedData = btoa(encodeURIComponent(savedData));
        setRequisites(encodedData);
      } catch (error) {
        console.error("Ошибка кодирования данных:", error);
      }
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="popup-overlay" onClick={onClose} onTouchStart={handleSwipeDown}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <p className="popup-title">Удостоверение личности</p>
        <p className="popup-description">Покажите QR-код сотруднику</p>

        <div className="qr-code-container">
          {requisites ? (
            <QRCodeCanvas value={requisites} size={200} />
          ) : (
            <p>Нет реквизитов для генерации QR-кода</p>
          )}
        </div>

        <p className="popup-text">или скажите код</p>
        <p className="popup-num">{randomCode}</p>

        <button className="close-btn" onClick={onClose}>
          x
        </button>
      </div>
    </div>
  );
}
